import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, CompanyDataService, ConfirmationDialogButtons, ModalService, ModelData, NotificationService, QueryParameter } from 'yt-ng-framework';
import { KomitentZrc } from '../komitent-zrc/komitent-zrc';
import { KomitentZrcView } from '../komitent-zrc/komitent-zrc-view';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'yt-komitent-update-from-nbs',
  templateUrl: './komitent-update-from-nbs.component.html'
})
export class KomitentUpdateFromNbsComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected companyDataService: CompanyDataService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) { }

  @Input() Parameters: QueryParameter[];
  @Output() RefreshDataClicked = new EventEmitter();

  pib: any;
  komitentID: any;
  itemsPre;
  itemsPosle;
  dataFromNBS;
  dodajNovi: string = '';
  TableColumns = [{}];
  showQuestion: boolean = true;
  showTable: boolean = false;
  showMessage: boolean = false;
  showQuestionButtons: boolean = true;
  showCloseButton: boolean = false;
  loadingInProgress: boolean = false;
  isDisabled: boolean = false;


  ngOnInit() {
    if(this.Parameters.length != 0){
      this.pib = this.Parameters[0].Value;
      this.komitentID = this.Parameters[1].Value;
      //this.dodajNovi = '1';
    }else{
      //this.dodajNovi = '0';
    }

    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      // DefaultSortKey: this.modelData.MainList.SortBy,
      // DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
      ,Height: '400px'
    }


    this.TableColumns = [
      { Name: 'Zrc', Label: 'KOMITENT.ZRC.SINGULAR', Visible: true, CanHide: false, Width: '50%' },
      { Name: 'Komitent', Label: 'KOMITENT.NAZIV.SINGULAR', Visible: true, CanHide: false, Width: '50%' },
      { Name: 'NacinIzmene', Label: 'KOMITENT.NACINIZMENE.SINGULAR', Visible: true, CanHide: false, Width: '50%' }
    ]
  }

  items = [];
  Config={};
  modelData: ModelData;

  Save() {
    this.loadingInProgress = true;
    this.isDisabled = true;
    this.baseDataService.Get("Komitent", "UpdateKomitentFromNbs", [ new QueryParameter("komitentID", this.komitentID)], KomitentZrcView )
      .subscribe({
        next: (data: any) => {
        if(data.length === 0){
          this.showMessage = true;
          this.showQuestion = false;
          this.showCloseButton = true;
          this.showQuestionButtons = false;
        }else{
          this.showQuestion = false;
          this.showTable = true;
          this.showCloseButton = true;
          this.showQuestionButtons = false;
          

          this.items = data;
  
        }  
        this.baseDataService.Post('Komitent', 'DeactivateLoseZrc', null, null)
          .subscribe({
            next: () => { },
              error: (err) => {
                // console.error("Greška u DeactivateLoseZrc:", err);
              }
          });
        },
        error: (err) => {
          const fullError = err.error as string;

          // Podeli string po znaku |
          const [errorCode, racun] = fullError.split('|');
          this.translateService.get(["UPDATEKOMITENTNBS.SINGULAR", errorCode])
            .subscribe(translate => {
              const message = `${translate[errorCode]}\u000A${racun}`;
              this.modalService.ShowConfirmationDialog(translate["UPDATEKOMITENTNBS.SINGULAR"], message, "warning", ConfirmationDialogButtons.Ok)
                .result.then(result => {

                  this.Close();
                });
            })
        }
      });

  }
  

  Close() {
    this.activeModal.dismiss();
  }
}
